'use client';
import { Option } from 'effect';

import { productRecommendedProductsPerPageDefault } from '../../../config/pagination';

import { fetchAssociatedProductsPageAtom } from '../../../effect/atom/products/fetchAssociatedProductsPage';
import {
  accessoriesPageSearchParamAtom,
  accessoriesTaxonSearchParamAtom,
} from '../../../effect/atom/products/recommendationsPagination';
import type { ProductBase } from '../../../effect/schema/openapi/backend';
import type { HydraCollectionResponseType } from '@vs-shop/schemas/openapi/response';
import type { AccessoriesUrlParams } from '../../../effect/utils/url/accessoriesUrlParams';
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult';
import { useAtomInitialValues } from '@effect/atom-react';

type Props = {
  productCode: string;
  accessoriesParams: AccessoriesUrlParams;
  initialAccessoriesData: HydraCollectionResponseType<typeof ProductBase>;
  initialTaxonCode: string | null;
};

export default function AccessoriesContextInitializer({
  productCode,
  accessoriesParams,
  initialAccessoriesData,
  initialTaxonCode,
}: Props) {
  useAtomInitialValues([
    [
      accessoriesTaxonSearchParamAtom,
      initialTaxonCode === null ? Option.none() : Option.some(initialTaxonCode),
    ],
    [
      accessoriesPageSearchParamAtom,
      accessoriesParams.page === 1 ? Option.none() : Option.some(accessoriesParams.page),
    ],
    [
      fetchAssociatedProductsPageAtom(
        productCode,
        initialTaxonCode,
        accessoriesParams.page,
        productRecommendedProductsPerPageDefault
      ),
      AsyncResult.success(initialAccessoriesData),
    ],
  ]);

  return null;
}
